import { getUserData } from '../../../utils/token'

const user = getUserData()
/**
|--------------------------------------------------
| Constants
|--------------------------------------------------
*/
export const MODULE_NAME = 'staffOfYearResult'

const GET_ITEMS_REQUEST = `${MODULE_NAME}/GET_ITEMS_REQUEST`
const GET_ITEMS_SUCCESS = `${MODULE_NAME}/GET_ITEMS_SUCCESS`
const GET_ITEMS_FAILURE = `${MODULE_NAME}/GET_ITEMS_FAILURE`

const GET_DETAILS_REQUEST = `${MODULE_NAME}/GET_DETAILS_REQUEST`
const GET_DETAILS_SUCCESS = `${MODULE_NAME}/GET_DETAILS_SUCCESS`
const GET_DETAILS_FAILURE = `${MODULE_NAME}/GET_DETAILS_FAILURE`
const CLEAR_DETAILS = `${MODULE_NAME}/CLEAR_DETAILS`

const CHANGE_FILTER = `${MODULE_NAME}/CHANGE_FILTER`

const EXPORT_USERS_REQUEST = `${MODULE_NAME}/EXPORT_USERS_REQUEST`
const EXPORT_USERS_SUCCESS = `${MODULE_NAME}/EXPORT_USERS_SUCCESS`
const EXPORT_USERS_FAILURE = `${MODULE_NAME}/EXPORT_USERS_FAILURE`

const GET_COMPANYIES_REQUEST = `${MODULE_NAME}/GET_COMPANYIES_REQUEST`
const GET_COMPANYIES_SUCCESS = `${MODULE_NAME}/GET_COMPANYIES_SUCCESS`
const GET_COMPANYIES_FAILURE = `${MODULE_NAME}/GET_COMPANYIES_FAILURE`

export const CONSTANTS = {
  GET_ITEMS_REQUEST,
  GET_ITEMS_SUCCESS,
  GET_ITEMS_FAILURE,
  GET_DETAILS_REQUEST,
  GET_DETAILS_SUCCESS,
  GET_DETAILS_FAILURE,
  EXPORT_USERS_REQUEST,
  EXPORT_USERS_SUCCESS,
  EXPORT_USERS_FAILURE,
  GET_COMPANYIES_REQUEST,
  GET_COMPANYIES_SUCCESS,
  GET_COMPANYIES_FAILURE
}

/**
|--------------------------------------------------
| Actions
|--------------------------------------------------
*/
export const getUsersReceiveVote = () => ({
  type: GET_ITEMS_REQUEST
})

export const getUsersGiveVote = userId => ({
  type: GET_DETAILS_REQUEST,
  userId
})
export const clearUsersGiveVote = () => ({
  type: CLEAR_DETAILS
})

export const changeFilter = filter => ({
  type: CHANGE_FILTER,
  filter
})

export const exportUsers = () => ({
  type: EXPORT_USERS_REQUEST
})

export const getListCompany = () => ({
  type: GET_COMPANYIES_REQUEST
})

/**
|--------------------------------------------------
| Handlers
|--------------------------------------------------
*/
const ActionHandler = {
  [GET_ITEMS_REQUEST]: state => ({ ...state, isLoading: true }),
  [GET_ITEMS_SUCCESS]: (state, { items }) => ({
    ...state,
    isLoading: false,
    items
  }),
  [GET_ITEMS_FAILURE]: state => ({ ...state, isLoading: false }),
  [GET_COMPANYIES_SUCCESS]: (state, { companies }) => ({
    ...state,
    companies
  }),
  [GET_DETAILS_REQUEST]: state => ({ ...state, isLoadingDetail: true }),
  [GET_DETAILS_SUCCESS]: (state, { details }) => ({
    ...state,
    isLoadingDetail: false,
    details
  }),
  [GET_DETAILS_FAILURE]: state => ({ ...state, isLoadingDetail: false }),
  [CLEAR_DETAILS]: state => ({ ...state, details: [] }),
  [CHANGE_FILTER]: (state, { filter }) => ({
    ...state,
    filter: { ...state.filter, ...filter }
  }),
  [EXPORT_USERS_REQUEST]: state => ({ ...state, isExporting: true }),
  [EXPORT_USERS_SUCCESS]: state => ({ ...state, isExporting: false }),
  [EXPORT_USERS_FAILURE]: state => ({ ...state, isExporting: false })
}

/**
|--------------------------------------------------
| Reducer
|--------------------------------------------------
*/
const initialState = {
  isLoading: false,
  isLoadingDetail: false,
  isExporting: false,
  items: [],
  details: [],
  filter: {
    companyID: user ? user.CompanyId : '',
    year: new Date().getFullYear()
  },
  companies: []
}

export default function staffOfYearResult(
  currentState = { ...initialState },
  action
) {
  const handler = ActionHandler[action.type]
  const nextState = handler ? handler(currentState, action) : currentState
  return nextState
}



// WEBPACK FOOTER //
// ./src/routes/StaffOfYearResult/modules/reducer.js